module.exports = __webpack_public_path__ + "img/2.17b8031e.png";